@if (displayImageBackground) {
  <app-background type="dynamic" [delayMs]="3000"></app-background>
}
<div class="main-container flex-row align-start-stretch"
  [style.background]="displayImageBackground ? 'transparent' : 'black'">
  @if (scriptLoaded) {
    <app-session-view class="flex-row align-start-stretch"
    (displayImageBackground)="onDisplayImageBackground($event)"></app-session-view>
  }
</div>